import * as React from 'react'
import { styled } from '@mui/material/styles'
import { Typography, Link } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { initTranslation } from 'app/translations/i18n'

const PREFIX = 'PrivacyPolicy'

const classes = {
  root: `${PREFIX}-root`,
  typographySpacing: `${PREFIX}-typographySpacing`,
  title: `${PREFIX}-title`
}

const Root = styled('div')(({ theme: { typography, spacing } }) => ({
  [`&.${classes.root}`]: {
    padding: spacing(3)
  },

  [`& .${classes.typographySpacing}`]: {
    marginTop: spacing(1)
  },

  [`& .${classes.title}`]: {
    fontWeight: typography.fontWeightLight,
    marginTop: spacing(3)
  }
}))

function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

const PrivacyPolicy = () => {
  const { t } = useTranslation()

  const query = useQuery()
  const lang = query.get('lang') || 'fi'

  initTranslation(lang)

  return (
    <Root className={classes.root}>
      <Typography variant="h4" gutterBottom>
        {t('privacy-policy-thinger')}
      </Typography>
      <Typography gutterBottom>{t('privacy-policy-thinger-description')}</Typography>

      <Typography className={classes.title} variant="h5">
        {t('data-controller')}
      </Typography>
      <div className={classes.typographySpacing}>
        <Typography>Thinger Solutions Oy (2751767-5)</Typography>
        <Typography>Joensuunkatu 7</Typography>
        <Typography>24100 Salo</Typography>
      </div>
      <div style={{ marginTop: 16 }}>
        <Typography>+3582 77980 </Typography>
        <Typography>
          <Link href="mailto:support@thinger.fi" underline="hover">
            support@thinger.fi
          </Link>
        </Typography>
      </div>

      <div style={{ marginTop: 16 }}>
        <Typography>{t('privacy-policy-thinger-user')}</Typography>
      </div>
      <Typography className={classes.title} variant="h5">
        {t('privacy-policy-purpose-of-the-service')}
      </Typography>
      <Typography className={classes.typographySpacing}>
        {t('privacy-policy-purpose-of-the-service-description')}
      </Typography>
      <Typography className={classes.title} variant="h5">
        {t('privacy-policy-personal-data-collect')}
      </Typography>
      <Typography className={classes.typographySpacing}>
        {t('privacy-policy-personal-data-collect-description')}
      </Typography>
      <div>
        <ul>
          <li>{t('name')}</li>
          <li>{t('phone')}</li>
          <li>{t('email')}</li>
        </ul>
        <Typography className={classes.typographySpacing}>{t('privacy-policy-additional-data-description')}</Typography>
        <ul>
          <li>{t('ip-addresses')}</li>
          <li>{t('privacy-policy-service-browsing-history')}</li>
          <li>{t('privacy-policy-browser-operation-system-basic-info')}</li>
        </ul>
        <Typography className={classes.title} variant="h5">
          {t('privacy-policy-what-data-is-used-for')}
        </Typography>
        <Typography className={classes.typographySpacing}>
          {t('privacy-policy-what-data-is-used-for-description-1')}
        </Typography>
        <Typography className={classes.typographySpacing}>
          {t('privacy-policy-what-data-is-used-for-description-2')}
        </Typography>
        <Typography className={classes.typographySpacing}>
          {t('privacy-policy-what-data-is-used-for-description-3')}
        </Typography>
        <Typography className={classes.title} variant="h5">
          {t('privacy-policy-data-storage')}
        </Typography>
        <Typography className={classes.typographySpacing}>{t('privacy-policy-data-storage-description-1')}</Typography>
        <Typography className={classes.typographySpacing}>{t('privacy-policy-data-storage-description-2')}</Typography>
        <Typography className={classes.title} variant="h5">
          {t('privacy-policy-disclosure-data-third-parties')}
        </Typography>
        <Typography className={classes.typographySpacing}>
          {t('privacy-policy-disclosure-data-third-parties-description')}
        </Typography>
        <Typography className={classes.title} variant="h5">
          {t('privacy-policy-rights-personal-data')}
        </Typography>
        <ul>
          <li>{t('privacy-policy-rights-personal-data-description-1')}</li>
          <li>{t('privacy-policy-rights-personal-data-description-2')}</li>
          <li>{t('privacy-policy-rights-personal-data-description-3')}</li>
        </ul>
        <Typography className={classes.typographySpacing}>
          {t('privacy-policy-rights-personal-data-description-4')}
        </Typography>
        <Typography className={classes.typographySpacing}>
          {`${t('privacy-policy-rights-personal-data-description-5')} `}
          <Link href="mailto:support@thinger.fi" underline="hover">
            support@thinger.fi
          </Link>{' '}
          {t('privacy-policy-rights-personal-data-description-6')}
        </Typography>
        <Typography className={classes.title} variant="h5">
          {t('privacy-policy-need-more-information')}
        </Typography>
        <Typography className={classes.typographySpacing}>
          {`${t('privacy-policy-contact-support')} `}
          <Link href="mailto:support@thinger.fi" underline="hover">
            support@thinger.fi
          </Link>
        </Typography>
      </div>
    </Root>
  )
}

export default PrivacyPolicy
